import React from 'react';
export default function SquareLongHairTop({
  lighter,
  light,
  dark,
}) {
  return (
<><g fill={lighter || light}><path d="M5.454 12.547s3.464-1.66 6.74-3.692c3.278-2.033 5.269-5.123 5.269-5.123S7.736 2.965 6.388 5.744c-1.348 2.779-.934 6.803-.934 6.803z"/><path d="M29.044 12.547s-3.993-1.66-7.27-3.692c-3.276-2.033-5.267-5.123-5.267-5.123s9.727-.767 11.075 2.012c1.348 2.779 1.462 6.803 1.462 6.803z"/></g></>); }
